export { default } from "./settings.web";
